import { Star } from 'lucide-react';

export const RatingStars = ({ value = 0, max = 5, size = 'sm', showValue = false }) => {
    const s = size === 'lg' ? 'h-5 w-5' : size === 'md' ? 'h-4 w-4' : 'h-3.5 w-3.5';
    return (
        <div className="inline-flex items-center gap-1" data-testid="rating-stars">
            {[...Array(max)].map((_, i) => (
                <Star key={i} className={`${s} ${i < Math.round(value) ? 'fill-amber-500 text-amber-500' : 'text-muted-foreground/40'}`} />
            ))}
            {showValue && <span className="ml-1 text-sm tabular-nums">{Number(value).toFixed(1)}</span>}
        </div>
    );
};
